<template>
  <div class="flex justify-center w-full">
    <div class="w-1/2">
      <div class="p-5 flex items-center flex-col">
        <div class="my-5 flex flex-col justify-center w-96 ">
          <h3 class="text-primary-dark">
            New password
          </h3>

          <div class="form-control w-96 mt-3">
            <label class="label">
              <span class="label-text text-lg text-primary-dark" />
            </label>
            <input
              v-model="password"
              type="password"
              :class="{'input-error': errorMsg}"
              placeholder="Password"
              class="input input-bordered w-full"
              @input="onPasswordInput"
            >
            <ul class="mt-4 ml-4 text-sm">
              <li :class="ruleClass(checks.length)">
                • At least 16 characters
              </li>
              <li :class="ruleClass(checks.lower)">
                • Has a lowercase letter
              </li>
              <li :class="ruleClass(checks.upper)">
                • Has an uppercase letter
              </li>
              <li :class="ruleClass(checks.digit)">
                • Has a number
              </li>
            </ul>
          </div>
          <div class="form-control w-96 mt-3">
            <label class="label">
              <span class="label-text text-lg text-primary-dark" />
            </label>
            <input
              v-model="password2"
              type="password"
              :class="{'input-error': errorMsg}"
              placeholder="Confirm password"
              class="input input-bordered w-full"
            >
          </div>
          <button
            @click="newPassword"

            class="btn bg-accent-green w-full mt-3"
          >
            Done
          </button>
          <p v-if="showLinkExpiredMsg">
            Link expired
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      password2: '',
      errorMsg: false,
      showLinkExpiredMsg: false,
      canSubmit: false
    }
  },
  computed: {
    checks () {
      const pw = this.password || ''
      const length = pw.length >= 16
      const lower = /[\p{Ll}]/u.test(pw)
      const upper = /[\p{Lu}]/u.test(pw)
      const digit = /\d/.test(pw)
      // const symbol = /[^\p{L}\p{N}\s]/u.test(pw)

      return { length, lower, upper, digit }
    },
    passwordErrors () {
      const errs = []
      const c = this.checks
      if (!c.length) errs.push('Password must be at least 16 characters long')
      if (!(c.lower && c.upper)) errs.push('Use both lowercase and uppercase letters')
      if (!c.digit) errs.push('Include at least one number')
      // if (!c.symbol) errs.push('Include at least one symbol (e.g. !@#)')

      return errs
    }
  },
  methods: {
    async newPassword () {
      if (this.password !== this.password2 || !this.canSubmit) {
        this.errorMsg = true
        return
      }
      const id = this.$route.params.id
      try {
        await this.$api.resetPassword(id, this.password)
        this.$router.push('/login')
      } catch (error) {
        if (error.response.status === 404) {
          this.showLinkExpiredMsg = true
        }
      }
    },
    ruleClass (ok) {
      return ok ? 'text-green-600' : 'text-red-600'
    },
    onPasswordInput (e) {
      this.password = e.target.value
      this.canSubmit = this.passwordErrors.length === 0 && !!this.password
      this.$emit('updateuser', this.user)
      this.$emit('cansubmit', this.canSubmit)
    }
  }
}
</script>

<style></style>
